import React, { useContext, useEffect, useState } from 'react';
import { Paper } from '@material-ui/core';

import { fbmApi as api } from 'api/fbm';
import { procurementApi } from 'api/procurement';
import { UserContext } from 'contexts/UserContext';
import { DataTable, Notifications } from 'shared';

function FBMManageAccounts() {
    const [rows, setRows] = useState([]);
    const [notification, setNotification] = useState({ text: null, level: null });
    const [shipperIdOptions, setShipperIdOptions] = useState([]);

    const { roles, user } = useContext(UserContext);

    const isFBMUser = user.fbm || !user.id;

    const canEditFBMAccounts = roles?.filter((role) => role.name.endsWith('EDIT_FBM_ACCOUNTS')).length >= 1;

    const getShipperIdOptions = async () => {
        const response = await procurementApi.getShippers();
        if (!response.status) {
            setNotification({ text: 'Failed to get shippers', level: 'error' });
            return;
        }

        setShipperIdOptions((response.data?.rows ?? []).map((row) => ({ text: row.name, value: row.id })));
    };

    const columns = [
        { accessor: 'companyName', Header: 'Company Name' },
        { accessor: 'fbmAccountName', Header: 'Account Name' },
        {
            accessor: 'inboundShipperIDs',
            Header: 'Inbound Shipper IDs',
            editable: true,
            editProps: {
                type: 'autocomplete-multiple',
                options: shipperIdOptions,
                multiple: true,
            },
        },
    ];

    const getRows = async () => {
        const response = await api.getFBMAccounts();

        if (response.status === false) {
            setNotification({ text: `No entries found ${response.msg}`, level: 'error' });
            setRows([]);
            return;
        }

        setRows(response.data.accounts);
    };

    useEffect(() => {
        if (!isFBMUser) {
            getShipperIdOptions();
            getRows();
        }
    }, [user]);

    if (isFBMUser) {
        return (
            <Paper>
                <h2>FBM Partner Accounts Management</h2>
                <p>Sorry this page is not available</p>
            </Paper>
        );
    }

    return (
        <Paper>
            <h2>FBM Partner Accounts Management</h2>

            <Notifications options={notification} />

            <DataTable
                columns={columns}
                data={rows}
                editable={canEditFBMAccounts}
                saveEdit={async ({ field, id, row, value }) => {
                    const res = await api.updateFBMAccountConfig(id, { [field]: value });
                    if (!res.status) {
                        setNotification({ text: res.msg, level: 'error' });
                        return false;
                    }

                    return true;
                }}
            />
        </Paper>
    );
}

export { FBMManageAccounts };
